import React from 'react';
import PropTypes from 'prop-types';
import { useClasses } from 'src/lib/styles';
import { cond } from 'src/utils';

const propTypes = {
  uppercase: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.string.isRequired,
};

const defaultProps = {
  uppercase: false,
  className: null,
};

function Xxs({ uppercase, className, children, ...props }) {
  const classes = useClasses('font-black', cond('uppercase')(uppercase), className);
  return (
    <h4 className={classes} {...props}>
      {children}
    </h4>
  );
}
Xxs.propTypes = propTypes;
Xxs.defaultProps = defaultProps;

function Xs({ uppercase, className, children, ...props }) {
  const classes = useClasses('text-xl', 'font-bold', cond('uppercase')(uppercase), className);
  return (
    <h3 className={classes} {...props}>
      {children}
    </h3>
  );
}
Xs.propTypes = propTypes;
Xs.defaultProps = defaultProps;

function Sm({ uppercase, className, children, ...props }) {
  const classes = useClasses('text-2xl', cond('uppercase')(uppercase), className);
  return (
    <h2 className={classes} {...props}>
      {children}
    </h2>
  );
}
Sm.propTypes = propTypes;
Sm.defaultProps = defaultProps;

export function Title({ uppercase, className, children, ...props }) {
  const classes = useClasses('text-3xl', 'font-black', cond('uppercase')(uppercase), className);
  return (
    <h1 className={classes} {...props}>
      {children}
    </h1>
  );
}
Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

Title.Xxs = Xxs;
Title.Xs = Xs;
Title.Sm = Sm;
